/**
 * Experiment gate for the expiring voucher reminder (GR-5151).
 *
 * Off for everyone until the experiment is set up. It is a hook so the experiment
 * lookup can replace the constant without changing callers.
 */
function useIsExpiringVoucherReminderEnabled(): boolean {
  return false
}

export default useIsExpiringVoucherReminderEnabled
